// Tarjeta «Registrar movimiento» del stock de tarjetas PCF: una acción por botón.
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/cn';
import { DetailCard } from './DetailCard';

export interface MovementAction<K extends string> {
    key: K;
    icon: LucideIcon;
    title: string;
    description: string;
    /** Color del borde izquierdo. */
    accent: string;
    /** Motivo por el que la acción no se puede usar ahora; ausente si se puede. */
    disabledReason?: string;
}

export function MovementActionsCard<K extends string>({
    actions,
    onPick,
}: {
    actions: readonly MovementAction<K>[];
    onPick: (key: K) => void;
}) {
    return (
        <DetailCard
            title="Registrar movimiento"
            aside={
                <span className="italic">
                    El saldo solo cambia por movimientos; cada uno queda en el libro.
                </span>
            }
        >
            <div className="grid grid-cols-3 gap-2">
                {actions.map(({ key, icon: Icon, title, description, accent, disabledReason }) => (
                    <button
                        key={key}
                        type="button"
                        disabled={disabledReason !== undefined}
                        title={disabledReason}
                        onClick={() => {
                            onPick(key);
                        }}
                        className={cn(
                            'flex flex-col gap-1 rounded-md border border-l-[3px] border-border bg-card px-3 py-3.5 text-left transition-colors hover:border-primary hover:bg-accent disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:border-border disabled:hover:bg-card',
                            accent,
                        )}
                    >
                        <Icon className="mb-1 size-5 text-muted-foreground" aria-hidden />
                        <span className="text-[12px] font-bold text-foreground">{title}</span>
                        <span className="text-[10.5px] leading-snug text-muted-foreground">
                            {description}
                        </span>
                    </button>
                ))}
            </div>
        </DetailCard>
    );
}
